<template>
  <fragment>
    <AppBody :subtitle="pageSubtitle" id="topo">
      <v-form ref="form">
        <v-row>
          <v-col cols="12" md="8" class="pb-1">
            <RegistrationData class="mb-4" />
            <Customization class="mb-4" />
            <Variants v-if="isACommomProduct" class="my-4" />
          </v-col>
          <v-col cols="12" md="4">
            <v-expansion-panels multiple v-model="panel" accordion>
              <EventGrouper v-if="isLink" class="mb-4" />
              <SalesPeriod v-if="notIsIframeOrLink" class="mb-4" />
              <InventoryManage v-if="notIsIframeOrLink" class="mb-4" />
              <LinkedEvents class="mb-4" />
              <OptionCancellation v-if="notIsLink" class="mb-4" />
              <AccessRules v-if="isACommomProduct" class="mb-4" />
              <Comission v-if="notIsLinkOrCortesy" class="mb-4" />
              <AdditionalInformation class="mb-4" />
              <Cashless v-if="allowCashless" class="mb-4" />
              <PaymentSettings v-if="notIsLink && isAdmin" class="mb-4" />
              <PreSale v-if="notIsLink" class="mb-4" />
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-form>
      <RegistrationActions
        :loading="$produtos_gerenciar.cadastro.loading"
        :actions="actions"
        fixed
        style="z-index: 2"
      ></RegistrationActions>
    </AppBody>
  </fragment>
</template>

<script>
import products from "@/mixins/products.js";
import AppBody from "@/layouts/components/AppBody.vue";
import RegistrationData from "@/components/produtos/gerenciar/RegistrationData.vue";
import AccessRules from "@/components/produtos/gerenciar/AccessRules.vue";
import SalesPeriod from "@/components/produtos/gerenciar/SalesPeriod.vue";
import AdditionalInformation from "@/components/produtos/gerenciar/AdditionalInformation.vue";
import Variants from "@/components/produtos/gerenciar/Variants.vue";
import OptionCancellation from "@/components/produtos/gerenciar/OptionCancellation.vue";
import Customization from "@/components/produtos/gerenciar/Customization.vue";
import RegistrationActions from "@/components/global/RegistrationActions.vue";
import InventoryManage from "@/components/produtos/gerenciar/InventoryManage.vue";
import Cashless from "@/components/produtos/gerenciar/Cashless.vue";
import Comission from "@/components/produtos/gerenciar/Comission.vue";
import EventGrouper from "@/components/produtos/gerenciar/EventGrouper.vue";
import LinkedEvents from "@/components/produtos/gerenciar/LinkedEvents.vue";
import PaymentSettings from "@/components/produtos/gerenciar/PaymentSettings.vue";
import PreSale from "@/components/produtos/gerenciar/PreSale.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "EventsSettings",
  metaInfo() {
    const title = this.$t("events.title");
    const subtitle = this.$t("events.event-config.create-edit");
    return {
      title: `${title} | ${subtitle} | ElevenTickets`,
      meta: [
        {
          property: "og:title",
          content: `${title} | ${subtitle} | ElevenTickets`,
        },
      ],
    };
  },
  mixins: [products],
  components: {
    AppBody,
    Comission,
    OptionCancellation,
    RegistrationData,
    AccessRules,
    SalesPeriod,
    AdditionalInformation,
    RegistrationActions,
    Variants,
    Customization,
    InventoryManage,
    Cashless,
    EventGrouper,
    LinkedEvents,
    PaymentSettings,
    PreSale,
  },
  data() {
    return {
      panel: [0, 1, 2],
    };
  },
  methods: {
    ...mapActions(["fetchLinkedEventsList"]),
    saveProduct() {
      const formValid = this.$refs.form.validate();

      if (this.notIsIframeOrLink) {
        // const descriptionValid = this.descriptionIsValid();

        // if (!descriptionValid) {
        //   this.$produtos_gerenciar.cadastro.dados_cadastrais.error.descritivo_pt_br = true;
        // }

        // if (formValid && descriptionValid) {
        this.$produtos_gerenciar.validarCadastro();
        // }
      } else {
        if (formValid) {
          this.$produtos_gerenciar.cadastro.loading = true;
          this.$produtos_gerenciar.validarCadastro();
        }
      }
    },
    // descriptionIsValid() {
    //   return (
    //     this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo_pt_br.trim() !==
    //     ""
    //   );
    // },
  },
  computed: {
    ...mapGetters([
      "storeInfo",
      "storeSequencial",
      "isEventProfile",
      "editEvent",
      "isAdmin",
      "digitalWallet",
    ]),
    actions() {
      return [
        {
          name: this.$t("events.save"),
          action: () => this.saveProduct(),
        },
        {
          name: this.$t("events.cancel"),
          action: () => this.$router.push({ name: "events" }),
        },
      ];
    },
    pageSubtitle() {
      const path = this.$route.path;
      if (path === "/gerenciar/cadastrar" || path === "/gerenciar/editar") {
        return this.$t("events.event-config.create-edit");
      } else {
        return this.$t("events.duplicate");
      }
    },
    isACommomProduct() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo !== "IFRAME" &&
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo !== "RECARGA" &&
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo !== "LINK"
      );
    },
    allowCashless() {
      const hasToken = this.storeInfo.token_cashless;
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "RECARGA" &&
        hasToken
      );
    },
    notIsIframeOrLink() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo !== "IFRAME" &&
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo !== "LINK"
      );
    },
    notIsLinkOrCortesy() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo !== "LINK" &&
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo !== "CORTESIA"
      );
    },
    notIsLink() {
      return this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo !== "LINK";
    },
    isLink() {
      return this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "LINK";
    },
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "YEAR"));
    },
    menu3(val) {
      val && setTimeout(() => (this.activePicker3 = "HOUR"));
    },
    menu4(val) {
      val && setTimeout(() => (this.activePicker4 = "HOUR"));
    },
  },
  beforeMount() {
    if (
      this.isEventProfile &&
      (this.$route.path === "/gerenciar/cadastrar" ||
        this.$route.path === "/gerenciar/duplicar")
    ) {
      this.$router.push({ name: "events" });
    }
    if (
      this.isEventProfile &&
      this.editEvent === 0 &&
      this.$route.path === "/gerenciar/editar"
    ) {
      this.$router.push({ name: "events" });
    }
  },
  mounted() {
    this.$produtos_gerenciar.getTipoTaxas();
    this.$produtos_gerenciar.getStatusProdutos();
    this.$produtos_gerenciar.getTiposProdutos();
    this.$produtos_gerenciar.getProdutosCategoria();

    this.fetchLinkedEventsList(this.storeSequencial);
    this.isEventProfile;
  },
  destroyed() {
    this.$produtos_gerenciar.limpaFormularioDeProduto();
  },
};
</script>
<style scoped>
html {
  scroll-behavior: smooth;
}

.btn-top {
  width: 48px !important;
  border-radius: 0.625rem;
  color: var(--dl-color-gray-white) !important;
  font-size: 0.875rem !important;
  background-color: #393939 !important;
  z-index: 3;
}
</style>
